import List from './List';
import type ListProps from './ListProps';

export default List;
export type { ListProps };
